import { Inject, Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { UserHelper } from 'src/app/providers/helpers/user-helper.service';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { ArticleService } from 'src/app/providers/model-services/article.service';
import { IInventoryHelper } from 'src/packages/mitsBasics';
import { StockObjectModel } from '../models';
import BasicStockInventoryHelperService from './basic-stock-inventory-helper';
import { BufferstockInventoryService } from '../providers/buffertock-inventory.service';
import { StockMovementService } from '../providers';
import { StockObjectService } from '../providers/stockObject.service';
import { IMovementQueue, MOVEMENT_QUEUE } from '../providers/movement-queue.token';

/**
 * Verbuchung auf den Lägern
 */
@Injectable({
  providedIn: 'root',
})
export class MachinestockInventoryHelperService
  extends BasicStockInventoryHelperService<StockObjectModel>
  implements IInventoryHelper
{
  constructor(
    protected stockInventoryService: BufferstockInventoryService,
    protected stockMovementService: StockMovementService,
    protected articleService: ArticleService,
    protected readonly stockObjService: StockObjectService,
    protected userHelper: UserHelper,
    @Inject(MOVEMENT_QUEUE) public queueService: IMovementQueue,
  ) {
    super(
      articleService,
      stockInventoryService,
      stockObjService,
      stockMovementService,
      stockObjService,
      userHelper,
      queueService
    );
  }
}
